import React, { Suspense, useLayoutEffect } from "react";
import "./Home.css";
import Hero from "./hero/hero";
import Nav from "./navbar/nav";
import apple from "../Media/apple 1.svg";
import holographicBg from "../Media/holographic.webp"; // Import the background image
import { Helmet } from "react-helmet";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Ourservice from "./ourservice/ourservice";
import Whatwedo from "./WhatWeDo/WhatWeDo";
import Founder from "./Founder/Founder";
import Clients from "./ourclients/clients";
import Blogs from "./blogs/blogs";

gsap.registerPlugin(ScrollTrigger);



const Home = () => {

  useLayoutEffect(() => {
  const ctx = gsap.context(() => {
    gsap.utils.toArray(".who-we-are-animate").forEach((element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          y: 60,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  });

  return () => ctx.revert();
}, []);


  return (
    <>
      <Helmet>
        <title>Althi Solutions | Innovative IT Services & Consulting</title>
        <meta
          name="description"
          content="Althi Solutions delivers custom SaaS, IT services, and consulting to help businesses grow with smart digital solutions, innovation, and technology-driven results."
        />
        <link rel="canonical" href="https://www.althisolutions.com/" />
        <meta name="robots" content="index, follow" />
        <link rel="preload" as="image" href={holographicBg} type="image/webp" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Althi Solutions | Innovative IT Services & Consulting"
        />
        <meta
          property="og:description"
          content="Althi Solutions delivers custom SaaS, IT services, and consulting to help businesses grow with smart digital solutions, innovation, and technology-driven results."
        />
        <meta property="og:url" content="https://www.althisolutions.com/" />
        <meta
          property="og:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
        <meta property="og:site_name" content="Althi Solutions" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@AlthiSolutions" />
        <meta name="twitter:creator" content="@AlthiSolutions" />
        <meta
          name="twitter:title"
          content="Althi Solutions | Innovative IT Services & Consulting"
        />
        <meta
          name="twitter:description"
          content="Althi Solutions delivers custom SaaS, IT services, and consulting to help businesses grow with smart digital solutions, innovation, and technology-driven results."
        />
        <meta
          name="twitter:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
      </Helmet>

      <div className="container-hero">
        <div className="hero">
          <img
            src={holographicBg}
            alt=""
            className="hero-bg"
            loading="eager"
            fetchPriority="high"
          />

          <div className="abovelayer"></div>

          <div className="hero-content">
            <Nav />
            <Hero />
          </div>
        </div>
          <Ourservice />
          <Whatwedo />
          <Founder />
          <Clients />
          <Blogs />
        <div className="whatsapp-chat">
          <a
            href="https://wa.me/917603908036"
            target="_blank"
            aria-label="Chat on WhatsApp"
            rel="noreferrer"
          >
            <img src={apple} alt="Chat with Althi Solutions on WhatsApp" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Home;
